// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export type AccountScopeState = "my-accounts" | "all-accounts";

type CustomerHealthToggleProps = {
  onSwitchClick: (state: AccountScopeState) => void;
  page: AccountScopeState;  
};

function CustomerHealthToggle(props: CustomerHealthToggleProps) {

  // Internal state for selected tab index (0 = all-accounts, 1 = my-accounts)
  const [value, setValue] = useState(props.page === "all-accounts" ? 0 : 1);

  //Add useEffect to sync the visual tab if the prop changes
  useEffect(() => {
    setValue(props.page === "all-accounts" ? 0 : 1);
  }, [props.page]);
  
  // This updates the visual tab indicator
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  
  // Calls the parent's callback function to notify the dashboard of the new account scope.
  const handleClick = (state: AccountScopeState) => {
    if (props.onSwitchClick) {
      props.onSwitchClick(state);
    }
  };

  return (
    <div style={{ border: '1px solid #ff7300', borderRadius: 25, height: '49.5px', width: 'fit-content' }}>
      <Tabs
        sx={{
          justifyContent: 'flex-start', "& button": { borderRadius: 10, boxShadow: 'insert', zIndex: 1 },
          "& button.Mui-selected": { color: '#fff' }
        }}
        value={value} 
        onChange={handleChange}
        TabIndicatorProps={{ sx: { backgroundColor: '#ff7300', height: '100%', borderRadius: 10 } }}
      >
        <Tab onClick={() => handleClick("all-accounts")} label="All Accounts" />
        <Tab onClick={() => handleClick("my-accounts")} label="My Accounts" /> 
      </Tabs>
    </div>
  );
};

export default CustomerHealthToggle;
